import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=2beed2d2&scoped=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beed2d2",
  null
  
)

export default component.exports